import {
  Component, h
} from '@stencil/core';
import { appRouter } from '../../../../global';

@Component({
  tag: 'app-not-found',
  styleUrl: 'NotFoundPage.css',
  shadow: false,
})
export class NotFoundPage {
  router = appRouter;

  render() {

    return <section class="section">
      <div class="content">
        <header class="header sticky top">
          <h2 class="cell pad">Page Not Found</h2>
        </header>
      </div>
    </section>;
  }
}
